import { NavItemsSimple } from '@/components/custom/nav-Items-simple'
import WorkspaceSidebarScaffold from '@/features/workspace/components/WorkspaceSidebarScaffold'
import { Sidebar } from '@/shared/components/ui/sidebar'
import React, { useState } from 'react'
import { useSpEditorProvider } from '@/features/screenplay/components/editor/SpEditorProvider'
import { useStoryboardStore } from '../store/useStoryboardStore'
import StoryboardGenerationDialog from './StoryboardGenerationDialog'

export function SbSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {

    const [isGenerationDialogOpen, setIsGenerationDialogOpen] = useState(false)

    const navItems: { name: string; emoji: string; onClick: () => void; disabled?: boolean }[] = [
        // Generate Storyboard moved to main content
    ]

    return (
        <>
            <WorkspaceSidebarScaffold>
                <NavItemsSimple navItems={navItems} header={{ title: 'Storyboard' }} />
            </WorkspaceSidebarScaffold>

            <StoryboardGenerationDialog
                open={isGenerationDialogOpen}
                onOpenChange={setIsGenerationDialogOpen}
            />
        </>
    )
}

export default SbSidebar
